/** @file Linear interpolation between two numbers. */

/** Returns a + (b - a) * t. */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}
